<template>
  <VWidget
    v-if="order.shipping_address && order.shipping_address.id && order.shipping"
    :title="$t('Shipping Method')"
    class="mb-4"
  >
    <div slot="widget-content">
      <v-radio-group
        v-model="order.shipping.method"
        @change="$emit('shipping-selected', $event)"
      >
        <v-radio
          v-for="method in shippings"
          :key="method.code"
          :label="`${method.name} - ${$options.filters.money(method.gross_price || method.price)}`"
          :value="method.code"
        />
      </v-radio-group>
    </div>
  </VWidget>
</template>

<script>

export default {
  name: 'OrderDraftShipping',

  props: {
    order: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      shippings: []
    }
  },

  async mounted () {
    this.shippings = await this.order.getShippingMethods()
  }
}
</script>
